// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Services
import { ApiService, SettingService } from '../../common/modules/core/services';
//Models
import { UpdateHolTransaction, DeleteHolTransaction, MakeHolTransaction, TransactionDetail, BookingItem, BookingList, BookingFilter,ClassList, ClassFilter, BookingDetail, BookingPayment, MakeTransaction } from '../models'

@Injectable()
export class BookingService {
    // Api Domain Url
    private apiUrl = '';
    // Url List for Booking Site 
    private bookingListUrl = '/hol/booking';
    private bookingNoteUrl = '/hol/booking/note';
    private classUrl = '/asa-classes';
    
    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
        // Get API service domain for communate.
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }


    /** 
     * Get all booking list 
     * @returns {BookingList[]} : list of the booking.
     */
    // getBookingList(): Observable<BookingList> {
    //     const requestUrl = this.apiUrl + this.bookingListUrl;

    //     return this.apiService.get<BookingList>(requestUrl);
    // }
    getBookingList(filter: BookingFilter): Observable<BookingList> {
        let requestUrl = this.apiUrl + this.bookingListUrl;
        let hasFilter = false;
        
        // Setup filter conditions
        for(let condition in filter) {
            if(filter[condition]) {
                if(hasFilter) {
                    requestUrl += '&';
                }
                else{
                    requestUrl += '?';
                    hasFilter = true;
                }

                requestUrl += condition + '=' + filter[condition];
            }
        }

        return this.apiService.get<BookingList>(requestUrl);
    }

    getBookingInfo(): Observable<BookingList>{
        let requestUrl = this.apiUrl + this.bookingListUrl;
        return this.apiService.get<BookingList>(requestUrl);
    }

    getBookingDetail(bookingId: number): Observable<BookingList> {
        let requestUrl = this.apiUrl + this.bookingListUrl + '?id=' + bookingId + '&page=1';
        return this.apiService.get<BookingList>(requestUrl);
    }

    getBookingTransaction(bookingId: number): Observable<TransactionDetail> {
        let requestUrl = this.apiUrl + this.bookingListUrl + '/' + bookingId;
        return this.apiService.get<TransactionDetail>(requestUrl);
    }

    makeHolTransactions(makeHolTransaction: MakeHolTransaction) {
        let requestUrl = this.apiUrl + this.bookingListUrl + '/' + makeHolTransaction.command.hol_booking_id + '/transaction';

        const body = JSON.stringify(makeHolTransaction.command);

        return this.apiService.post(requestUrl, body);
    }

    updateHolTransactions(updateTransaction: UpdateHolTransaction) {
        let requestUrl = this.apiUrl + this.bookingListUrl + '/' + updateTransaction.command.hol_booking_id + '/transaction';

        const body = JSON.stringify(updateTransaction.command);

        return this.apiService.patch(requestUrl, body);
    }
    
    deleteHolTransactions(deleteHolTransaction: DeleteHolTransaction) {
        let requestUrl = this.apiUrl + this.bookingListUrl + '/' + deleteHolTransaction.hol_booking_id + '/transaction';
        
        const body = JSON.stringify(deleteHolTransaction)

        return this.apiService.deletePost(requestUrl, body);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Update Booking Holiday Class
    updateBooking(query: any): Observable<any> {
        const requestUrl = this.apiUrl + this.bookingListUrl;
        const body = JSON.stringify(query);
        return this.apiService.patch(requestUrl, body);
    }
    // ────────────────────────────────────────────────────────────────────────────────
    // Update Booking Note
    updateBookingNote(query: any): Observable<any> {
        const requestUrl = this.apiUrl + this.bookingNoteUrl;
        const body = JSON.stringify(query);
        return this.apiService.patch(requestUrl, body);
    }
}


// WEBPACK FOOTER //
// ./src/holiday/services/BookingService.ts